module.exports = __webpack_public_path__ + "static/media/mv05.ef735a25.jpg";